import React from 'react';
import { TIERS, type BillingCycle, type TierId } from './tiersData';
import { PricingCard } from './PricingCard';

interface PricingGridProps {
  billingCycle: BillingCycle;
  /** Optional: enables tier-hierarchy rendering (current / upgrade / downgrade). */
  currentTier?: TierId;
  /** Optional custom handler for card CTAs. */
  onSelect?: (tier: TierId) => void;
}

// OQ8 Pax: ordem Free → Pro → Business em mobile (DOM natural, upsell progressivo)
export const PricingGrid: React.FC<PricingGridProps> = ({ billingCycle, currentTier, onSelect }) => {
  return (
    <section
      aria-label="Planos disponíveis"
      className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto mb-16 sm:mb-20"
    >
      {TIERS.map((tier) => (
        <PricingCard
          key={tier.id}
          tier={tier}
          billingCycle={billingCycle}
          currentTier={currentTier}
          onSelect={onSelect}
        />
      ))}
    </section>
  );
};
